import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LxlibLocaleModule } from '@lxlib/theme';
import { LxlibUtilModule } from '@lxlib/util';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { G2MiniProgressComponent } from './mini-progress.component';

const COMPONENTS = [G2MiniProgressComponent];

@NgModule({
  imports: [CommonModule, LxlibUtilModule, LxlibLocaleModule, NzToolTipModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class G2MiniProgressModule {}
